export default "__VITE_ASSET__Bti8YJE4__"